import { FC, PropsWithChildren } from 'react';

import { Footer, Header } from '@components';

type Props = {
	className?: string;
};

export const Page: FC<PropsWithChildren<Props>> = ({ children, className = '' }) => (
	<>
		<Header />

		<main className={`main ${className}`}>{children}</main>

		<Footer />
	</>
);

export default Page;
